/**
 * Simple screen visibility router (menu | catalog | hud | results | gallery | account).
 */
export default class ScreenRouter {
  constructor() {
    this.screens = {
      menu: document.getElementById('screen-menu'),
      catalog: document.getElementById('screen-catalog'),
      hud: document.getElementById('screen-hud'),
      results: document.getElementById('screen-results'),
      gallery: document.getElementById('screen-gallery'),
      account: document.getElementById('screen-account'),
      rankings: document.getElementById('screen-rankings')
    };
    this.current = null;
  }

  show(name) {
    for (const [key, el] of Object.entries(this.screens)) {
      if (!el) continue;
      const active = key === name;
      el.classList.toggle('hidden', !active);
      if (active) this.current = key;
    }
  }

  hideAllGameplayUi() {
    this.screens.hud?.classList.add('hidden');
    this.screens.results?.classList.add('hidden');
  }
}
